export function assertEnabledApi(value, apiName) {
    if (process.env.NODE_ENV !== 'production') {
        if (value == null) {
            throw new Error(`Invalid access to flowAPI.${apiName} - must be enabled in .module.json`);
        }
    }
}
//# sourceMappingURL=assert-enabled-api.js.map